var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstructionsIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 18.04V20.04H0.9934C0.44476 20.04 0 19.5847 0 19.0482V1.03184C0 0.484089 0.44749 0.0400391 0.9985 0.0400391H13L17.9998 5.04004V12.04H16V6.04004H12V2.04004H2V18.04H9ZM11.4646 17.5047L15.0001 21.0402L19.9498 16.0905L18.5356 14.6762L15.0001 18.2118L12.8788 16.0905L11.4646 17.5047Z",
    fill: "#787E82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstructionsIcons);
export default __webpack_public_path__ + "static/media/instructions-icons.a3f1ced80e72efd5facd01be97f63b9c.svg";
export { ForwardRef as ReactComponent };